/**
 * Number formatting for figures the backend computes. Assessments store to 3
 * decimal places and the UI shows 2, so formatting happens once, at display.
 */

/** Up to 2dp, trailing zeros dropped. Counts and report tables. */
export const formatNumber = (value: number): string =>
  value.toLocaleString(undefined, { maximumFractionDigits: 2 });

/** Exactly 2dp, so a column of computed results lines up. */
export const formatMetric = (value: number): string =>
  value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

/** AUD at 2dp. */
export const formatAud = (value: number): string => `$${formatMetric(value)}`;
